import React from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TextField } from "@mui/material";

const ResponseTimeSettingsForm = ({
  responseTimeSettings: rts,
  handleOnChange,
  inputSelected,
}) => {
  const gasKeys = ["TRS", "CO", "CO2", "NO", "NO2", "NOx", "O2", "SO2", "H2O"];
  const gasesArray = gasKeys.filter((k) => rts[k]).map((k) => rts[k]);

  return (
    <Table size="small" sx={{ m: 2 }}>
      <TableHead>
        <TableRow>
          <TableCell />
          {gasesArray.map((comp, idx) => (
            <TableCell key={idx} align="center">{comp.name}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>Zero</TableCell>
          {gasesArray.map((comp, idx) => (
            <TableCell key={`zero_${idx}`} align="center">
              <TextField
                size="small"
                value={comp.zeroResponse ?? ""}
                onChange={(e) => handleOnChange(e.target.value, comp.name, "zeroResponse")}
                onClick={(e) => inputSelected(e, comp.name + "|zeroResponse")}
                error={comp.zeroResponse !== "" && comp.zeroResponse != null && isNaN(Number(String(comp.zeroResponse).replace(",", ".")))}
                helperText={comp.zeroResponse !== "" && comp.zeroResponse != null && isNaN(Number(String(comp.zeroResponse).replace(",", "."))) ? "Input a number" : ""}
                sx={{ width: 100 }}
              />
            </TableCell>
          ))}
        </TableRow>
        <TableRow>
          <TableCell>Span</TableCell>
          {gasesArray.map((comp, idx) => (
            <TableCell key={`span_${idx}`} align="center">
              <TextField
                size="small"
                value={comp.spanResponse ?? ""}
                onChange={(e) => handleOnChange(e.target.value, comp.name, "spanResponse")}
                onClick={(e) => inputSelected(e, comp.name + "|spanResponse")}
                error={comp.spanResponse !== "" && comp.spanResponse != null && isNaN(Number(String(comp.spanResponse).replace(",", ".")))}
                helperText={comp.spanResponse !== "" && comp.spanResponse != null && isNaN(Number(String(comp.spanResponse).replace(",", "."))) ? "Input a number" : ""}
                sx={{ width: 100 }}
              />
            </TableCell>
          ))}
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default ResponseTimeSettingsForm;
